export default "__VITE_ASSET__388af71b__"